import React, { useEffect } from 'react';

import { PaletteMode } from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import {
  createTheme,
  StyledEngineProvider,
  Theme,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles';
import useCookie from '../components/_hook/useCookie';
import { COOKIE_KEY } from '../components/constant/cookie';
import 'react-image-lightbox/style.css';

interface IProps {
  children: React.ReactElement;
}

declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}

export default function ThemeProvider(props: IProps) {
  const { cookies } = useCookie([COOKIE_KEY.LANGUAGE, COOKIE_KEY.THEME_MODE]);
  const { children } = props;
  const [mode, setMode] = React.useState<PaletteMode>('light');

  useEffect(() => {
    setMode(cookies[COOKIE_KEY.THEME_MODE]);
    if (cookies[COOKIE_KEY.THEME_MODE] === 'dark') {
      document.body.style.backgroundColor = 'black';
      document.body.style.color = 'white';
    } else {
      document.body.style.backgroundColor = '#f5f5f5';
      document.body.style.color = 'black';
    }
  }, [cookies[COOKIE_KEY.THEME_MODE]]);

  // https://material-ui.com/customization/color/#color-tool
  let mainFontFamily = 'Montserrat';

  if (cookies[COOKIE_KEY.LANGUAGE] === 'th') {
    mainFontFamily = 'Prompt';
  }

  if (cookies[COOKIE_KEY.LANGUAGE] === 'zh-CN') {
    mainFontFamily = 'Noto Sans SC';
  }

  const theme = createTheme({
    palette: {
      mode,
      ...(mode === 'light'
        ? {
            primary: {
              main: '#00B6F0',
              // dark : '#1D7EA1',
              contrastText: '#fff',
            },
            secondary: {
              main: '#8AC65A',
              // dark : '#DCFDC2',
              contrastText: '#fff',
            },
          }
        : {
            primary: {
              main: '#00B6F0',
              // dark : '#1D7EA1',
              contrastText: '#fff',
            },
            secondary: {
              main: '#8AC65A',
              // dark : '#DCFDC2',
              contrastText: '#fff',
            },
          }),
    },
    spacing: 8,
    typography: {
      fontFamily: [
        mainFontFamily,
        '"Open Sans"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      htmlFontSize: 16,
      fontSize: 14,
      button: {
        textTransform: 'none',
      },
    },
    components: {
      MuiTextField: {
        defaultProps: {
          variant: 'standard',
        },
      },
      MuiFormControl: {
        defaultProps: {
          variant: 'standard',
        },
      },
      MuiSelect: {
        defaultProps: {
          variant: 'standard',
        },
      },
    },
  });

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {children}
        </LocalizationProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
}
